const Wallet = ({ size=24, color="#060606", ...props }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
    >
        <path d="M3 11h3.75a2 2 0 0 1 1.6.8l.45.6a4 4 0 0 0 6.4 0l.45-.6a2 2 0 0 1 1.6-.8H21"/>
        <path d="M3 7h18"/>
        <rect x="3" y="3" width="18" height="18" rx="2"/>
    </svg>
);

export default Wallet;
